import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Tag } from 'antd';
import { useDeleteCargoFromTripTask } from 'api/trip-task/use-delete-cargo-from-trip-task';
import { useGetCargoTrips } from 'api/trips/use-get-cargo-trips';
import { isTripStarted } from 'shared/utils/trips/is-trip-started';
import type { ITripTaskItemCargoesProps } from 'components/trips/trip-tasks/components/trip-task-item-cargoes/types';
import styles from './trip-task-item-cargoes.module.scss';

export const TripTaskItemCargoes: React.FC<ITripTaskItemCargoesProps> = ({ trip, tripTaskId, cargoTripIds }) => {
  const { t } = useTranslation();
  const { data: cargoTrips, isLoading } = useGetCargoTrips(trip.id);
  const { mutateAsync: deleteCargoFromTripTask } = useDeleteCargoFromTripTask(trip.id, tripTaskId);

  const handleConfirmDeleteCargoFromTripTask = (e: React.MouseEvent, cargoTripId: number) => {
    e.preventDefault();
    const cargoCompositeId = preparedCargoCompositeId(cargoTripId);

    Modal.confirm({
      title: t('trip:delete_cargo_from_trip_task'),
      content: t('trip:delete_cargo_from_trip_task_confirm', { id: cargoCompositeId }),
      okText: t('common:delete'),
      okType: 'danger',
      cancelText: t('common:cancel'),
      onOk: async () => {
        await deleteCargoFromTripTask([cargoTripId]);
      },
    });
  };

  const preparedCargoCompositeId = (cargoTripId: number) => {
    const cargoTrip = cargoTrips?.find((cargoTrip) => cargoTrip.id === cargoTripId);

    return cargoTrip ? `TK-${cargoTrip.cargoId}` : 'unknown';
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.container}>
      {cargoTripIds.map((cargoTripId) => (
        <Tag
          key={cargoTripId}
          className={styles.tag}
          closable={!isTripStarted(trip.status) && cargoTripIds.length > 1}
          onClose={(e) => handleConfirmDeleteCargoFromTripTask(e, cargoTripId)}>
          {preparedCargoCompositeId(cargoTripId)}
        </Tag>
      ))}
    </div>
  );
};
